import React, { PureComponent } from 'react';
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import PropTypes from 'prop-types';

class DropdownSelect extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownValue: props.value || 'Select option',
      dropdownOpen: false
    };

    this.toggle = this.toggle.bind(this);
    this.changeValue = this.changeValue.bind(this);
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  changeValue(e) {
    this.setState({ dropdownValue: e.currentTarget.textContent });
    this.props.onChange(e.currentTarget.getAttribute('id'));
  }

  render() {
    const { dropdownOpen, dropdownValue } = this.state;
    const { options, id } = this.props;

    return (
      <ButtonDropdown isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret id={id}>
          {dropdownValue}
        </DropdownToggle>
        <DropdownMenu>
          {options.map(({ value, text }) => {
            return (
              <DropdownItem
                active={text === dropdownValue}
                id={value}
                key={value}
                onClick={this.changeValue}
              >
                {text}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}

DropdownSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool
};

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/formFields/DropdownSelect.js